import peachApi from './peachApi'

const logout = () => peachApi.delete({ url: '/auth/token' })

export default logout
